export default __webpack_public_path__ + "static/face2faces-0261e945fdc3bbd7c709e29f9e613b02.png";